// frontend/src/pages/FacilitiesPage/FacilitiesPage.jsx
import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import styles from './FacilitiesPage.module.css';
import tabsStyles from '../../components/Tabs/Tabs.module.css';

const TABS_CONFIG = [
  { id: 'floor-plans', label: 'Floor Plans', path: '/facilities' }, // Main entry point
  { id: 'outdoor-areas', label: 'Outdoor Areas', path: '/facilities/outdoor-areas' },
  { id: 'kitchen', label: 'Kitchen', path: '/facilities/kitchen' },
];

const FacilitiesPage = () => {
  return (
    <main className={styles.facilitiesPageContainer}>
      <h1 className={`${styles.pageTitle} page-main-title`}>Facilities</h1>
      <div className={tabsStyles.tabsContainer}>
        {TABS_CONFIG.map((tab) => (
          <NavLink
            key={tab.id}
            to={tab.path}
            // Use `end` prop for the main "Floor Plans" tab to avoid it staying active on sub-routes
            end={tab.path === '/facilities'}
            className={({ isActive }) =>
              `${tabsStyles.tabButton} ${isActive ? tabsStyles.active : ''}`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
      <div className={styles.tabContent}>
        <Outlet />
      </div>
    </main>
  );
};

export default FacilitiesPage;